<ds-modal
  #termsAndConditionsModal
  [ds-modal-trigger-for]="termsAndConditionsModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '585px', height: '824px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header size="md">{{ 'header.termsAndConditionsModal.title' | translate }}</ds-box-header>
  <ds-box-content>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.termsAndConditionsModal.firstSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.termsAndConditionsModal.firstSection.content.paragraph1' | translate }}</p>
    <p class="text-regular mb-8x">{{ 'header.termsAndConditionsModal.firstSection.content.paragraph2' | translate }}</p>
    <p class="text-regular mb-8x">{{ 'header.termsAndConditionsModal.firstSection.content.paragraph3' | translate }}</p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.termsAndConditionsModal.secondSection.title' | translate }}
    </p>
    <p class="text-regular">
      {{ 'header.termsAndConditionsModal.secondSection.content.paragraph1' | translate }}
    </p>
    <p class="text-regular mb-8x">
      {{ 'header.termsAndConditionsModal.secondSection.content.paragraph2' | translate }}
    </p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.termsAndConditionsModal.thirdSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.termsAndConditionsModal.thirdSection.content' | translate }}</p>
  </ds-box-content>
  <ds-box-footer>
    <button id="btn-close-modal" ds-button #dsModalDismissElement>
      {{ 'common.buttons.close' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
